/**
 * Enum for Country ID values.
 * Maps country names to their corresponding numeric identifiers from the "Country" database table.
 *
 * @readonly
 * @enum {number}
 *
 * @property {number} UNITED_STATES - Country ID for the United States.
 * @property {number} CANADA - Country ID for Canada.
 */
export const COUNTRY_ID = {
  UNITED_STATES: 1, // See database table "Country"
  CANADA: 2,
};
